/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Account/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AutomatedEventNotifications from './AutomatedEventNotifications/index'
import Chairs from './Chairs/index'
import ClockIn from './ClockIn/index'
import Content from './Content/index'
import DndProvider from 'DesignSystem/DndProvider/react'
import EmbeddableCoreMessageListener from './EmbeddableCoreMessageListener/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import InactivityWarning from './InactivityWarning/index'
import ManualAutomations from 'DesignSystem/ManualAutomations/index'
import NewPatient from './NewPatient/index'
import PatientNotifications from './PatientNotifications/index'
import PatientOverlay from './PatientOverlay/index'
import React from 'react'
import Search from './Search/index'
import TimeOutOfSyncNotice from './TimeOutOfSyncNotice/index'
import Topbar from './Topbar/index'
import UpdateNotice from './UpdateNotice/index'
import UserNotifications from './UserNotifications/index'
import UserPilot from 'DesignSystem/UserPilot/react'
import WaitingRoom from './WaitingRoom/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Account({
  children,
  viewPath = "/App/Account"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<UserPilot
  viewPath={`${viewPath}/UserPilot`}
/>
<ManualAutomations
  viewPath={`${viewPath}/ManualAutomations`}
/>
<UpdateNotice
  viewPath={`${viewPath}/UpdateNotice`}
/>
<TimeOutOfSyncNotice
  viewPath={`${viewPath}/TimeOutOfSyncNotice`}
/>
<InactivityWarning
  viewPath={`${viewPath}/InactivityWarning`}
/>
<EmbeddableCoreMessageListener
  viewPath={`${viewPath}/EmbeddableCoreMessageListener`}
/>
<AutomatedEventNotifications
  viewPath={`${viewPath}/AutomatedEventNotifications`}
/>
<Search
  viewPath={`${viewPath}/Search`}
/>
<ClockIn
  viewPath={`${viewPath}/ClockIn`}
/>
<NewPatient
  viewPath={`${viewPath}/NewPatient`}
/>
<PatientOverlay
  viewPath={`${viewPath}/PatientOverlay`}
/>
<PatientNotifications
  viewPath={`${viewPath}/PatientNotifications`}
/>
<UserNotifications
  viewPath={`${viewPath}/UserNotifications`}
/>
<div
  data-testid="Account.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Topbar
  viewPath={`${viewPath}/Topbar`}
/>
<div
  data-testid="Account.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-zc1EJ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-2-zc1EJ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-3-zc1EJ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-zc1EJ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<WaitingRoom
  viewPath={`${viewPath}/WaitingRoom`}
/>
<DndProvider
  viewPath={`${viewPath}/DndProvider`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</DndProvider>
<Chairs
  viewPath={`${viewPath}/Chairs`}
/>
</div>
</div>
{children}
</React.Fragment>)
}